import * as React from "react";
import { selectTournamentLeagueMinimumLevel } from "../../balancingSelectors/selectBalancingFarmEvents";
import { IdStyles } from "../../less/IdStyles";
import { utilNumber } from "../../utils/utilNumber";
import { EventType } from "../balancing/types/BalancingCore";
import { BigCharacter } from "../generic/big-character/BigCharacter";
import { IdBigCharacter } from "../generic/big-character/IdBigCharacter";
import { TextLoca } from "../generic/text/TextLoca";
import { IdTeasers } from "./IdTeasers";
import { teaserLocaMap } from "./teaserLocaMap";
import { TournamentTeaserDescription } from "./TournamentTeaserDescription";
export var TabTournamentTeaser = function (_a) {
    var type = _a.type;
    var title = teaserLocaMap.get(type).title;
    var foundLevel = type === IdTeasers.PlayerLevelTooLowPlayerLeague
        ? selectTournamentLeagueMinimumLevel(EventType.PlayerLeague)
        : selectTournamentLeagueMinimumLevel(EventType.CoopLeague);
    var replacementLevelString = utilNumber.format(foundLevel || 0);
    return (React.createElement("div", null,
        React.createElement(BigCharacter, { name: IdBigCharacter.BigCharacter_Rita, idStyle: IdStyles.TeaserCharacterLevelLeft }),
        React.createElement("div", { className: IdStyles.TeaserDescriptionContainerLarge + " teaser-container" },
            React.createElement("p", null,
                React.createElement(TextLoca, { className: IdStyles.TextBoldPrimary, id: title })),
            React.createElement("br", null),
            React.createElement("p", null,
                React.createElement(TournamentTeaserDescription, { type: type, replacementLevelString: replacementLevelString })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/TabTournamentTeaser.tsx
// module id = 944
// module chunks = 3